import {
  Button,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@clearcover/atlas';
import { usePolicyContext } from 'Policies/utils/PolicyContext/PolicyContext';
import React, { FC, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { FormInput } from 'Shared/components';
import { useLazyApi } from 'Shared/services/Api';
import styles from './styles.module.css';

export const EditTelematicsDiscountForm: FC<{
  closeModal: () => void;
  hasTelematicsDiscount: boolean;
}> = ({ closeModal, hasTelematicsDiscount }) => {
  const history = useHistory();

  const { id: policyId, draftId } = useParams<{
    id: string;
    draftId: string;
  }>();
  const { refetchHandler } = usePolicyContext();

  const [{ loading, error }, updateTelematicsDiscount] = useLazyApi<{
    draftId: string;
  }>({
    method: 'POST',
    url: '/telematics/discount',
  });
  const [hasDiscount, updateHasDiscount] = useState(hasTelematicsDiscount);

  return (
    <div
      data-testid={'edit-telematics-discount-form'}
      className={styles.container}
    >
      <ModalHeader className={styles.header}>
        {' '}
        <h5>Edit Discount</h5>
      </ModalHeader>
      <ModalContent className={styles.content}>
        <h1>ClearClaims+ Discount</h1>
        <span>
          You can manually enroll or unenroll a customer from ClearClaims+
          below.
        </span>
        <div>
          <FormInput
            variant="radioButtonGroup"
            name="insure-other-lines"
            data-testid="insure-other-lines-select"
            options={{ yes: 'yes', no: 'no' }}
            value={hasDiscount ? 'yes' : 'no'}
            onChange={value => {
              if (value === 'no') {
                updateHasDiscount(false);
              } else {
                updateHasDiscount(true);
              }
            }}
            label="Does the customer wish to enroll Clearcover ClearClaims+?"
          />
          <div className={styles.error}>{error?.message} </div>
        </div>
      </ModalContent>
      <ModalFooter>
        <div className={styles.buttonGroup}>
          <Button
            variant="danger-secondary"
            isSubmitting={false}
            onClick={closeModal}
          >
            Cancel
          </Button>
          <Button
            isSubmitting={loading}
            onClick={() => {
              updateTelematicsDiscount({
                data: {
                  policyId,
                  discount: hasDiscount ? 'ADD' : 'REMOVE',
                },
              }).then(({ data }) => {
                draftId === data.draftId
                  ? refetchHandler()
                  : history.push(`/policies/${policyId}/draft/${data.draftId}`);
              });
            }}
          >
            Save & Continue
          </Button>
        </div>
      </ModalFooter>
    </div>
  );
};
